import { QueryHookOptions, gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'

export const getBlockedUserQuery = gql`
  query BlockedUserQuery($blockeeId: String!) {
    BlockedUsers(where: { blockee: { equals: $blockeeId } }) {
      docs {
        id
        blockee {
          id
          fullName
        }
        createdAt
      }
    }
  }
`

export interface BlockedUsersQueryInput {
  blockeeId: string
}

export interface BlockedUsersQueryOutput {
  BlockedUsers: {
    docs: {
      id: string
      blockee: {
        id: string
        fullName: string
        avatar?: {
          url: string
        }
      }
      createdAt: string
    }[]
  }
}

export const useBlockedUserQuery = (
  options: QueryHookOptions<BlockedUsersQueryOutput, BlockedUsersQueryInput>
) =>
  usePersistedCacheQuery<BlockedUsersQueryOutput, BlockedUsersQueryInput>(getBlockedUserQuery, {
    ...options,
  })
